<template>
  <b-modal id="upload-image-show-modal" ref="productionInstructionBookmarkModal" :hide-header="true" :hide-footer="true" :no-close-on-backdrop="true">
    <b-overlay :show="overlayShow" rounded="sm">
      <div>
        <b-button @click="hideModal()" aria-label="Close" class="close" v-if="attendeeType === this.consts.attendeeType.florist">
          <b-icon-x font-scale="2"></b-icon-x>
        </b-button>
      </div>
      <div
        class="d-flex align-items-center justify-content-center flex-nowrap px-2 mb-3"
        v-if="attendeeType === consts.attendeeType.florist">
        <div class="flex-grow-1 d-flex justify-content-center">
          <p class="h4 mb-0">ブックマーク一覧</p>
        </div>
        <div class="d-flex align-items-center flex-shrink-0" style="gap: 0.5rem;">
          <div class="d-flex align-items-center">
            <div class="prod-inst-show-indicator"></div>
            <span class="ml-2 prod-inst-show-text text-nowrap">制作指示に表示中</span>
          </div>
        </div>
      </div>
      <div class="text-center mb-3" v-else>
        <p class="h4">ブックマーク一覧</p>
      </div>
      <div class="col-sm-12 overflow-auto p-0">
        <div v-if="imageData !== null && imageData.length">
          <div class="card-deck py-3 w-100 customer-img-col-cnt m-0" v-for="(uploadImages, index) in imageData" :key="index">
            <div class="card position-relative border-0 bg-unset card-sqr-gray card-h-250px mb-5" v-for="(uploadImage, i) in uploadImages" :key="'imageCard' + i">
              <div class="mt-2 mr-2 mb-2 ml-1 position-absolute" style="z-index:1">
                <label class="form-check-label labex-box-white py-1 px-2 my-1 ml-1" :for="'delete' + index + '-' + i" style="font-size: 1rem">
                  <input type="checkbox" class="checkbox-scale-larger mt-2" :id="'delete' + index + '-' + i" v-model="uploadImage['delete']">
                  削除
                </label>
                <label class="form-check-label labex-box-white py-1 px-2 my-1 ml-2" style="font-size: 1rem" :for="'isProdInstShow' + index + '-' + i">
                  <input
                    type="checkbox"
                    class="checkbox-scale-larger mt-2"
                    :id="'isProdInstShow' + index + '-' + i"
                    true-value="表示する"
                    false-value=""
                    v-model="uploadImage['isProdInstShow']">
                  制作指示に表示
                </label>
              </div>
              <div class="p-0 upload-image h-100">
                <img
                  :src="uploadImage['image']"
                  class="h-100 ar-3-2"
                  :class="{'prod-inst-show-border': uploadImage['originIsProdInstShow'] === '表示する'}">
                <div class="row" v-if="attendeeType === consts.attendeeType.florist">
                  <div class="col-2">
                    <span class="border border-dark rounded-circle btn p-1 mt-1 ml-2" @click="movePage(uploadImage['name'], 'ブックマーク', 'goToProductionInstruction')">
                      <b-icon-vector-pen scale="1"></b-icon-vector-pen>
                    </span>
                  </div>
                  <div class="col-10 d-flex align-items-center justify-content-end">
                    <div
                      class="mr-2 position-relative custom-category-wrapper"
                      style="font-size: 1rem">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary dropdown-toggle custom-category-btn"
                        disabled>
                        <span class="custom-category-text">{{ getCategoryDisplayText(uploadImage['categories']) }}</span>
                      </button>
                    </div>
                    <label
                      class="form-check-label labex-box-white py-1 px-2 my-1 ml-2 d-flex align-items-center sort-order-label"
                      style="font-size: 1rem; height: 38px;">
                      <span class="mr-1">並び順</span>
                      <input
                        type="text"
                        class="form-control sort-order-input"
                        :value="uploadImage['sortOrder']|| ''"
                        disabled
                        readonly
                        maxlength="2">
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="uploadImages.length < imageRowMaxNum">
              <div class="card position-relative border-0 bg-unset" v-for="i in (imageRowMaxNum - uploadImages.length)" :key="'emptyCard' + i">
                <div class="p-0"></div>
              </div>
            </template>
          </div>
        </div>
        <div v-else>
          <p class="mt-5 text-center">画像がありません</p>
        </div>
      </div>
      <div class="text-center my-5" v-if="imageData !== null && imageData.length && attendeeType === consts.attendeeType.florist">
        <b-button variant="primary" @click="saveProdInstShow()" :disabled="loginStatus['referenceFlag'] === '1'">制作指示表示状態を保存</b-button>
      </div>
    </b-overlay>
    <CommonModal ref="commonModal" @confirmOk="saveProdInstShowSend" />
  </b-modal>
</template>
<script>
import CommonModal from '@/components/CommonModal'
import BookmarkImageListModel from '@/models/BookmarkImageListModel'
import BookmarkImageProductionInstructionShowModel from '@/models/BookmarkImageProductionInstructionShowModel'
import CookieInfoModel from '@/models/CookieInfoModel'

export default {
  name: 'ProductionInstructionBookmarkModal',
  components: { CommonModal },
  data () {
    return {
      overlayShow: false,
      attendeeType: '',
      imageRowMaxNum: 3,
      imageData: {},
      bookmarkImageData: {'bookmarkImages': []},
      loginStatus: ''
    }
  },
  props: {
    'cookieProjectNumber': {
      type: String,
      default: ''
    }
  },
  methods: {
    showModal (attendeeType) {
      this.attendeeType = attendeeType
      this.setApiData()
      this.$refs.productionInstructionBookmarkModal.show()
    },
    hideModal () {
      this.$refs.productionInstructionBookmarkModal.hide()
    },
    uploadImageData () {
      const store = this.bookmarkImageData
      if (!store) {
        return null
      }
      const length = Math.ceil(store.bookmarkImages.length / this.imageRowMaxNum)
      this.imageData = new Array(length).fill().map((_, i) =>
        store.bookmarkImages.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
      this.imageData.map(images => {
        images.map(image => {
          // kintone上の見積表示状態
          image.originIsProdInstShow = image.isProdInstShow
          // 削除フラグ
          image.delete = false
          if (!image.productionInstructionDisplayCategory || image.productionInstructionDisplayCategory === '') {
            image.categories = []
          } else {
            image.categories = image.productionInstructionDisplayCategory.split(',').map(c => c.trim()).filter(c => c !== '')
          }
          // 並び順の初期化（非活性表示用）
          if (image.sortOrder !== null && image.sortOrder !== undefined && image.sortOrder > 0) {
            image.sortOrder = Number(image.sortOrder)
          } else {
            image.sortOrder = null
          }
        })
      })
      this.bookmarkImageData['bookmarkImages'] = []
      console.log(this.imageData)
    },
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      let startFlag = true
      let result = ''
      let sumImageNum = 0
      let params = {'startNo': 0, 'prodInstFlag': true}
      while (startFlag) {
        result = await BookmarkImageListModel.apiSetStore(this.$bvModal, params, () => {
        })
        sumImageNum += result.ImageNum
        params['startNo'] += result.ImageNum
        for (let i in result.bookmarkImages) {
          this.bookmarkImageData['bookmarkImages'].push(result.bookmarkImages[i])
        }
        if (sumImageNum === result.totalImageNum) {
          startFlag = false
        }
      }
      this.uploadImageData()

      this.loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      this.overlayShow = false
    },
    movePage (fileName, projectType, target) {
      fileName = fileName.split('.')[0]
      this.hideModal()
      this.$emit(target, fileName, projectType)
    },
    saveProdInstShow: async function () {
      // cookieの打合せIDが変化しているかチェック
      let cookieProjectNumberCheckResult = await this.cookieProjectNumberCheck()
      if (!cookieProjectNumberCheckResult) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
        return
      }
      let hasDelete = false
      this.imageData.map(images => {
        images.map(image => {
          if (image.delete === true) {
            hasDelete = true
          }
        })
      })
      if (hasDelete) {
        this.$refs.commonModal.msgBoxConfirm('「削除」にチェックした画像を削除します。よろしいですか？')
      } else {
        this.saveProdInstShowSend()
      }
    },
    saveProdInstShowSend: async function () {
      this.overlayShow = true
      let params = []
      this.imageData.map(images => {
        images.map(image => {
          params.push({
            'fileName': image.name,
            'isProdInstShow': image.isProdInstShow,
            'tableID': image.tableID,
            'delete': !!image.delete
          })
        })
      })
      await BookmarkImageProductionInstructionShowModel.apiSetStore(this.$bvModal, params, (response) => {
        this.imageData.forEach(images => {
          images.forEach(image => {
            image.originIsProdInstShow = image.isProdInstShow
          })
        })
        this.overlayShow = false
      })
      this.setApiData()
    },
    cookieProjectNumberCheck: async function () {
      let currentCookieProjectNumber = ''
      let params = ['projectNumber']
      currentCookieProjectNumber = await CookieInfoModel.apiSetStore(this.$bvModal, params, () => {})
      if (currentCookieProjectNumber['cookieInfo'] === this.cookieProjectNumber) {
        return true
      } else {
        return false
      }
    },
    getCategoryDisplayText (categories) {
      if (!categories || categories.length === 0) {
        return ''
      }
      if (categories.length === 1) {
        return categories[0]
      }
      return `${categories[0]} 他${categories.length - 1}件`
    }
  }
}
</script>
<style>
.upload-image {
  position: relative;
}
.upload-image-delete-btn {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 30px;
}
.custom-category-btn {
  padding: 0.5rem 0.75rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  height: 38px !important;
  min-width: 120px !important;
  max-width: 120px !important;
  display: inline-flex !important;
  align-items: center !important;
  vertical-align: middle !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: left !important;
  border-radius: 0.25rem !important;
}

.custom-category-text {
  display: inline-block !important;
  max-width: 85px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>

<style scoped>
/* 制作指示に表示中のインジケーター */
.prod-inst-show-indicator {
  width: 35px;
  height: 24px;
  border: 3px solid #28a745;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(40, 167, 69, 0.35);
  background-color: #ffffff;
  flex-shrink: 0;
}

.prod-inst-show-text {
  font-size: 0.95rem;
  color: #333;
}

/* 制作指示に表示中の画像枠 */
.prod-inst-show-border {
  border: 3px solid #28a745 !important; /* 緑色の枠 */
}

/* カテゴリボタンと並び順の高さ統一 */
.custom-category-wrapper,
.sort-order-label {
  height: 38px;
}

.sort-order-input {
  width: 40px;
  height: 30px;
  text-align: center;
  padding: 0.25rem;
}

/* 小画面対応 */
@media (max-width: 575px) {
  .h4 {
    font-size: 1.1rem;
  }
  .prod-inst-show-text {
    font-size: 0.85rem;
  }
  .btn-primary {
    font-size: 0.9rem;
    padding: 0.25rem 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductionInstructionBookmarkModal.vue